module.exports = __webpack_public_path__ + "static/img/thumb_1.b483449.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_1.jpg
// module id = ogS4
// module chunks = 0